<template>
  <div class="sign-in-cloudapp-button">
    <a :href="destination" v-b-modal.login-modal id="sign-in-cloudapp" class="cloudapp-btn sign-in-btn" data-testid="login-modal" @click="trackSignIn()">
      <span>Sign In</span>
    </a>
  </div>
</template>

<script>
import track from '@/src/tracking';

export default {
  props: {
    link: { type: String }
  },
  methods: {
    trackSignIn: function(){
      track('sign_in_click', { hashid: this.$root.item.id, viewer: "dropper" });
    }
  },
  computed: {
    destination: function() {
      return this.link ? this.link : "#"
    }
  }
}
</script>
